import ManualEntryBetType from './components/ManualEntryBetType'
import ManualEntryInputNumber from './components/ManualEntryInputNumber'

export interface ManualEntryProps<T> {
  onBetTypeSelect: (types: T) => void
  onBetNumberSelect: (number: string, types: T[]) => void
  betTypes: {
    key: T
    label: string
  }[]
  selectedBetTypes: T[]
  inputDigit: number
}

export default function ManualEntry<T extends string>({
  betTypes,
  selectedBetTypes,
  onBetTypeSelect,
  onBetNumberSelect,
  inputDigit,
}: ManualEntryProps<T>) {
  return (
    <div className="p-4 sm:p-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Left Side - Select Bet */}
        <ManualEntryBetType
          betTypes={betTypes}
          selectedBetTypes={selectedBetTypes}
          onToggle={(key: T) => {
            onBetTypeSelect(key)
          }}
        />

        {/* Right Side - Input Number */}
        {/*
          The key prop is set to selectedBetTypes.join('-') to force React to remount
          ManualEntryInputNumber whenever the bet type selection changes. This ensures
          that the input value inside ManualEntryInputNumber is reset when the bet type is toggled.
        */}
        <ManualEntryInputNumber
          key={selectedBetTypes.join('-')}
          maxDigits={inputDigit}
          onComplete={(number: string) => {
            onBetNumberSelect(number, selectedBetTypes)
          }}
        />
      </div>
    </div>
  )
}
